// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #F3F4F6;
}

.login-card {
  background-color: #FFFDFC;
  padding: 3rem;
  border-radius: 0.8rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 40rem;
}

.login-card h1 {
  color: #2C3948;
  font-size: 2.4rem;
  font-weight: 600;
  margin-bottom: 2rem;
  text-align: center;
}

.login-container .form-group {
  margin-bottom: 2rem;
}

.login-container .form-group label {
  display: block;
  color: #2C3948;
  font-size: 1.4rem;
  margin-bottom: 0.8rem;
}

.login-container .form-group input {
  width: 100%;
  padding: 1.2rem;
  border: 1px solid #E5E7EB;
  border-radius: 0.8rem;
  font-size: 1.6rem;
  color: #2C3948;
}

.login-container .form-group input:focus {
  outline: none;
  border-color: #DA7027;
}

.error-message {
  background-color: #FEF2F2;
  color: #DC2626;
  padding: 1rem;
  border-radius: 0.6rem;
  margin-bottom: 2rem;
  font-size: 1.4rem;
}

.toggle-password-btn {
  position: absolute;
  right: 1.2rem;
  background: none;
  border: none;
  padding: 0.6rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-password-btn svg {
  width: 2rem;
  height: 2rem;
  color: #2C3948;
}

.toggle-password-btn:hover svg {
  color: #DA7027;
}

.login-footer {
  margin-top: 2.4rem;
}

.register-link {
  margin-bottom: 1.2rem;
  font-size: 1.4rem;
  color: #2C3948;
}

.register-link a {
  color: #DA7027;
  text-decoration: none;
  font-weight: 500;
}

.register-link a:hover {
  text-decoration: underline;
}

.forgot-password-link {
  font-size: 1.4rem;
}

.forgot-password-link a {
  color: #DA7027;
  text-decoration: none;
  font-weight: 500;
}

.forgot-password-link a:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".login-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 100vh;\r\n  background-color: #F3F4F6;\r\n}\r\n\r\n.login-card {\r\n  background-color: #FFFDFC;\r\n  padding: 3rem;\r\n  border-radius: 0.8rem;\r\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\r\n  width: 100%;\r\n  max-width: 40rem;\r\n}\r\n\r\n.login-card h1 {\r\n  color: #2C3948;\r\n  font-size: 2.4rem;\r\n  font-weight: 600;\r\n  margin-bottom: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n.login-container .form-group {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.login-container .form-group label {\r\n  display: block;\r\n  color: #2C3948;\r\n  font-size: 1.4rem;\r\n  margin-bottom: 0.8rem;\r\n}\r\n\r\n.login-container .form-group input {\r\n  width: 100%;\r\n  padding: 1.2rem;\r\n  border: 1px solid #E5E7EB;\r\n  border-radius: 0.8rem;\r\n  font-size: 1.6rem;\r\n  color: #2C3948;\r\n}\r\n\r\n.login-container .form-group input:focus {\r\n  outline: none;\r\n  border-color: #DA7027;\r\n}\r\n\r\n.error-message {\r\n  background-color: #FEF2F2;\r\n  color: #DC2626;\r\n  padding: 1rem;\r\n  border-radius: 0.6rem;\r\n  margin-bottom: 2rem;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.toggle-password-btn {\r\n  position: absolute;\r\n  right: 1.2rem;\r\n  background: none;\r\n  border: none;\r\n  padding: 0.6rem;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.toggle-password-btn svg {\r\n  width: 2rem;\r\n  height: 2rem;\r\n  color: #2C3948;\r\n}\r\n\r\n.toggle-password-btn:hover svg {\r\n  color: #DA7027;\r\n}\r\n\r\n.login-footer {\r\n  margin-top: 2.4rem;\r\n}\r\n\r\n.register-link {\r\n  margin-bottom: 1.2rem;\r\n  font-size: 1.4rem;\r\n  color: #2C3948;\r\n}\r\n\r\n.register-link a {\r\n  color: #DA7027;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.register-link a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.forgot-password-link {\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.forgot-password-link a {\r\n  color: #DA7027;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.forgot-password-link a:hover {\r\n  text-decoration: underline;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
